import { render, staticRenderFns } from "./prepagata.vue?vue&type=template&id=3784edf7&"
import script from "./prepagata.vue?vue&type=script&lang=js&"
export * from "./prepagata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports